import gql from 'graphql-tag'

export const CACHE_STATE_LOADING = gql`
    query Variables {
        loading @client
        loadingMore @client
    }
`